import { render, staticRenderFns } from "./LinkUs.vue?vue&type=template&id=3439bb18&scoped=true"
import script from "./LinkUs.vue?vue&type=script&lang=js"
export * from "./LinkUs.vue?vue&type=script&lang=js"
import style0 from "./LinkUs.vue?vue&type=style&index=0&id=3439bb18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3439bb18",
  null
  
)

export default component.exports